<template>
  <transition name="modal-fade">
    <Modal @close="close">
      <div class="ly_pop_wrap fix">
        <div class="ly_pop_content ly_pop_libr">
          <div class="ly_pop_head">
            <h2>새 책장 추가</h2>
            <a class="btn_ly_close svg_close" @click="close">
              <span>{{ $t('library.deletemodal.close') }}</span>
            </a>
          </div>
          <div class="ly_inner">
            <div class="editer_libr">
              <p>
                새 책장의 이름을 입력해 주세요.
                <span>({{ nameLength }}/40)</span>
              </p>
              <div class="editer_form">
                <div class="editer_text_wrap n_line">
                  <input
                    class="editer_input_t"
                    type="text"
                    placeholder="책장 이름"
                    maxlength="40"
                    :value="name"
                    @input="onInput"
                    @keypress.enter="createNew"
                    @compositionstart="isComposing = true"
                    @compositionupdate="onCompositionUpdate"
                    @compositionend="onCompositionEnd"
                  />
                  <span :class="`${inputState}_subtext`">
                    {{ inputSubMsg }}
                  </span>
                  <div class="info">
                    새 책장을 추가하시면 도서를 이동하실 수 있어요.
                  </div>
                </div>
              </div>
            </div>
            <div class="btn_wrap text-center">
              <button type="submit" class="box_btn dull" @click="close">
                취소
              </button>
              <button type="submit" class="box_btn" @click="createNew">
                저장
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </transition>
</template>
<script>
import {
  BOOKSHELF_CREATE,
  BOOKSHELF_BOOK_GET_LIST,
  BOOKSHELF_SET_CURRENT
} from '@/store/types'

export default {
  name: 'CreateNewModal',
  data() {
    return {
      name: '',
      inputState: '',
      inputSubMsg: '',
      isComposing: false,
      nameLength: 0
    }
  },
  computed: {
    baseBookshelves() {
      return this.$store.getters.getBookshelves.filter(
        (e) => e.bookshelfTp !== 'GFT' && e.bookshelfTp !== 'PRS'
      )
    }
  },
  watch: {
    name() {
      this.inputSubMsg = ''
    }
  },
  methods: {
    async createNew() {
      const { name } = this

      if (name != '') {
        if (this.baseBookshelves.find((e) => e.bookshelfNm === name)) {
          this.inputState = 'error'
          this.inputSubMsg = '이미 동일한 이름의 책장이 있습니다.'
          return
        }
        try {
          const response = await this.$store.dispatch(BOOKSHELF_CREATE, {
            name
          })
          const newBookshelf = response.data.result
          if (newBookshelf && newBookshelf.bookshelfId) {
            const id = newBookshelf.bookshelfId
            this.$store.commit(BOOKSHELF_SET_CURRENT, id)
            this.$store.dispatch(BOOKSHELF_BOOK_GET_LIST, { id })
          }
        } catch (e) {
          // console.error('책장 생성 실패:', e)
        }
        this.name = ''
        this.close()
      }
    },
    close() {
      this.$emit('close')
    },
    onInput(e) {
      const val = e.target.value
      this.name = val
      this.nameLength = val.length
    },
    onCompositionUpdate(e) {
      const val = e.target.value
      this.nameLength = val.length
    },
    onCompositionEnd(e) {
      this.isComposing = false
      const val = e.target.value
      this.name = val
      this.nameLength = val.length
    }
  }
}
</script>
<style lang="scss" scoped>
.error_subtext {
  display: block;
}
.info {
  display: flex;
  gap: 5px;
  margin-top: 10px;
  &::before {
    content: '';
    display: block;
    width: 18px;
    height: 18px;
    background: url('../../assets/images/warning.png') no-repeat;
  }
}
.ly_pop_libr .ly_inner {
  padding: 25px 40px;
}
.btn_wrap {
  display: flex;
}
.editer_libr + .btn_wrap .box_btn {
  height: 38px;
  font-size: 16px;
  color: #fff;
}
</style>
